<template>
  <IQOS title="Lucky spin" required>
    <template v-if="!isEnabled">
      <p class="iqos-comment qrw-paragraph-md mt-16">
        Ваші гості можуть приймати участь у розіграші призів від закладу
      </p>
    </template>
    <div class="gap-row-xs mt-16" v-else>
      <div class="gap-row-1xs">
        <div class="qrw-label-sm v1-grey-7-color bold">Системи</div>
        <div class="gap-column-1xs">
          <BaseCheckbox class="w-100" v-model="settings.modes.inside"> INSIDE </BaseCheckbox>
          <BaseCheckbox class="w-100" v-model="settings.modes.takeaway">
            TAKEAWAY
          </BaseCheckbox>
          <BaseCheckbox class="w-100" v-model="settings.modes.delivery">
            DELIVERY
          </BaseCheckbox>
        </div>
      </div>

      <BaseDivider color="v1-grey-4" />

      <div class="gap-row-1xs">
        <div class="qrw-label-sm v1-grey-7-color bold">Термін дії</div>
        <div class="gap-column-xs">
          <v-date-picker
            v-model="range.start"
            class="campaign-period-widget w-100"
            locale="uk"
            is-dark
            color="green"
          />
          <v-date-picker
            v-model="range.end"
            class="campaign-period-widget w-100"
            locale="uk"
            is-dark
            color="green"
          />
        </div>
      </div>

      <BaseDivider color="v1-grey-4" />

      <div class="gap-row-1xs">
        <div class="qrw-label-sm v1-grey-7-color bold">
          Частота участі
        </div>
        <BaseSelect v-model.number="settings.min_interval" @blur="save">
          <option :value="0">без обмежень</option>
          <option :value="1">раз в годину</option>
          <option :value="12">раз в 12 годин</option>
          <option :value="24">один раз в день</option>
          <option :value="48">один раз у 2 дні</option>
          <option :value="168">один раз в тиждень</option>
          <option :value="720">один раз в місяць</option>
        </BaseSelect>
      </div>

      <BaseDivider color="v1-grey-4" />

      <div class="gap-column-xs">
        <div class="gap-row-1xs w-100">
          <div class="qrw-label-sm v1-grey-7-color bold">
            Шанс виграшу | перший spin
          </div>
          <BaseUnitInput
            fullWidth
            type="number"
            v-model.number="settings.first_chance"
            unitPlaceholder="%"
            @blur="save"
          />
        </div>

        <div class="gap-row-1xs w-100">
          <div class="qrw-label-sm v1-grey-7-color bold">
            Шанс виграшу | наступні spinи
          </div>
          <BaseUnitInput
            fullWidth
            type="number"
            v-model.number="settings.repeat_reduce_chance"
            unitPlaceholder="%"
            @blur="save"
          />
        </div>
      </div>

      <BaseDivider color="v1-grey-4" />

      <div class="gap-row-1xs">
        <div class="w-100 gap-column-xs" v-if="settings.prizes.length">
          <div class="qrw-label-sm w-100 v1-grey-7-color bold">Приз</div>
          <div class="qrw-label-sm w-100 v1-grey-7-color bold">
            Шанс виграшу
          </div>
        </div>
        <div
          class="w-100 gap-column-xs"
          v-for="(prize, index) in settings.prizes"
          :key="index"
        >
          <ProductSearchInput
            @clear="removePrize(index)"
            class="w-100"
            :value="prize"
          />
          <BaseUnitInput
            fullWidth
            type="number"
            placeholder="Шанс"
            v-model.number="prize.chance"
            unitPlaceholder="%"
            @blur="save"
          />
        </div>
        <div class="w-100 gap-column-xs">
          <ProductSearchInput
            placeholder="Введіть назву страви щоб додати приз"
            class="w-100"
            @input="addPrize"
          />
        </div>
      </div>
      <BaseButton
        @click="$router.push('/table/casino')"
        variant="secondary"
        size="md"
        class="w-100"
      >
        Переглянути історію розіграшів
      </BaseButton>
    </div>

    <template #actions>
      <IQOSToggle v-model="isEnabled" />
    </template>
  </IQOS>
</template>

<script>
import ProductSearchInput from "@/components/menu/ProductSearchInput.vue";

import moment from 'moment'

export default {
  data() {
    return {
      newPrize: {
        product_id: null,
        menu_id: null,
      },
      range: {
        start: null,
        end: null
      }
    };
  },
  methods: {
    save() {
      this.$store.commit("patchCafeGeneralData", {
        roulette: this.settings,
      });
      this.$store.dispatch("saveCafe");
    },
    addPrize({ menu_id, product_id }) {
      this.settings.prizes.push({
        menu_id,
        product_id,
        chance: 0,
      });
      this.save();
    },
    removePrize(index) {
      this.settings.prizes.splice(index, 1);
      this.save();
    },
  },
  watch: {
    'range': {
      deep: true,
      handler() {
        this.settings.start_date = this.range.start || null;
        this.settings.end_date = this.range.end || null;
        this.save();
      }
    }
  },
  mounted() {
    if (this.settings.start_date) this.range.start = moment(
      this.settings.start_date
    ).startOf('day').toDate();

    if (this.settings.end_date) this.range.end = moment(
      this.settings.end_date
    ).endOf('day').toDate();

    this.$store
      .dispatch("menu/fetchMenus");
  },
  computed: {
    settings() {
      return this.$store.state.cafe.roulette;
    },
    isEnabled: {
      get() {
        return this.settings.enabled;
      },
      set(v) {
        this.$set(this.settings, "enabled", v);
        this.save();
      },
    },
  },
  components: {
    ProductSearchInput,
  },
};
</script>

<style scoped>
.dashboard-page-content {
  padding-bottom: 264px !important;
}
</style>